import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import AdForm from 'pages/ArcAd/AdForm'
import useAction from 'utils/useAction'
import * as actions from 'actions/views/arcAds'
import { selectors as arcAdsSelectors } from 'domains/arcAds'

const ArcAdModal = ({ closeModal, ...data }) => {
  const fetchAds = useAction(actions.fetchArcAds)
  const fetchAdDetails = useAction(actions.fetchArcAdDetails)
  const page = useSelector(arcAdsSelectors.getPage)
  const searchString = useSelector(arcAdsSelectors.getSearchString)

  const adData = data.ad || data
  const adId = adData?.id || null
  const campaignId = data.campaignId || null
  const callback = data.callback

  // Fetch fresh ad details when modal opens with an existing ad
  useEffect(() => {
    if (adId) {
      fetchAdDetails({ id: adId })
    }
  }, [adId, fetchAdDetails])

  const handleSuccess = () => {
    // If there's a custom callback (from ExpandedRow), use it
    if (typeof callback === 'function') {
      callback()
    } else {
      // Otherwise use the default refresh (from Arc Ad page)
      fetchAds({
        page,
        search: searchString,
        filters: {},
        sorter: {sort: 'created_at'}
      })
    }
    closeModal()
  }

  const handleCancel = () => {
    closeModal()
  }

  return (
    <AdForm
      adId={adId}
      campaignId={campaignId}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
    />
  )
}

export default ArcAdModal